// extracted by mini-css-extract-plugin
module.exports = {"body":"style__body__vpRhD","content":"style__content__AG8wj","footer":"style__footer__XgfWH","container":"style__container__7MaYn"};